import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';

function Contact() {
  const [name, setName] = useState<string>('Test Name');
  const [email, setEmail] = useState<string>('test@example.com');
  const [message, setMessage] = useState<string>('Test message');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const form = useRef();

  const sendEmail = (e: any) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    if (name !== '' && email !== '' && message !== '') {
      var templateParams = {
        name: name,
        email: email,
        message: message,
        to_email: 'losharhammond@gmail.com',
      };

      console.log(templateParams);
      // Initialize EmailJS with your public key
      emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'default_key');
      
      emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_id',
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_id',
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'api_key'
      ).then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Email sent successfully!');
        },
        (error) => {
          console.log('FAILED...', error);
          alert('Failed to send email. Please try again.');
        },
      );
      setName('');
      setEmail('');
      setMessage('');
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <div className="section-code-header">
            <span className="code-keyword">function</span>
            <span className="code-variable">contactMe</span>
            <span className="code-bracket">()</span>
            <span className="code-bracket">{`{`}</span>
          </div>
          <p className="section-comment">// Reach out for AI projects, product strategy, or technical leadership</p>
          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className='contact-form'
          >
            <div className='form-flex'>
              <TextField
                required
                id="outlined-required"
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                error={nameError}
                helperText={nameError ? "Please enter your name" : ""}
                sx={{
                  input: {
                    color: '#050f0b', // Ensures text color is visible
                    backgroundColor: '#fff', // Ensure background is white
                    fontSize: '1rem',
                  },
                }}
              />
              <TextField
                required
                id="outlined-required"
                label="Email / Phone"
                placeholder="How can I reach you?"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                error={emailError}
                helperText={emailError ? "Please enter your email or phone number" : ""}
                sx={{
                  input: {
                    color: '#050f0b',
                    backgroundColor: '#fff',
                    fontSize: '1rem',
                  },
                }}
              />
            </div>
            <TextField
              required
              id="outlined-multiline-static"
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              error={messageError}
              helperText={messageError ? "Please enter the message" : ""}
              sx={{
                input: {
                  color: '#050f0b',
                  backgroundColor: '#fff',
                  fontSize: '1rem',
                },
              }}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail}>
              Send
            </Button>
          </Box>
          <div className="section-code-footer">{`}`}</div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
